import React from 'react';
import Helmet from 'react-helmet';

// Gtag fallback
function gtag() {
	if (global.gtag) return gtag(arguments);
	global.dataLayer.push(arguments);
}

//
// === Initialize global Analytics ===
//

export const initialize = ({
	googleAnalyticsPropertyId,
	googleLinkerDomains,
}) => {
	// Initialize Gtag
	global.dataLayer = global.dataLayer || [];
	gtag('js', new Date());

	return {
		identify(
			customerId,
			email,
			firstName = null,
			lastName = null,
			phone = null,
			city = null,
			state = null,
			zip = null,
			country = null,
		) {
			try {
				global._learnq &&
					global._learnq.push([
						'identify',
						{
							$email: email,
							$first_name: firstName,
							$last_name: lastName,
						},
					]);

				global.heap && global.heap.identify(customerId);

				global.fbq &&
					global.fbq('init', '2181321151939736', {
						em: email,
						ph: phone,
						fn: firstName,
						ln: lastName,
						external_id: customerId,
						ct: city,
						st: state,
						zp: zip,
						cn: country,
					});

				global.pintrk &&
					global.pintrk('load', process.env.GATSBY_PINTEREST_ID, {
						em: email,
					});
			} catch (error) {
				console.warn(error);
			}
		},
		pageview(location) {
			gtag('config', googleAnalyticsPropertyId, {
				page_path: location.pathname,
				linker: {
					domains: googleLinkerDomains,
				},
			});

			// global.ga && global.ga('send', 'pageview');

			global.fbq && global.fbq('track', 'PageView');

			global.pintrk && global.pintrk('page');
		},
		viewCollection(items = []) {
			gtag('event', 'view_item_list', {items});
		},
		viewProduct(item = {}) {
			gtag('event', 'view_item', {items: [item]});

			global.fbq &&
				global.fbq('track', 'ViewContent', {
					content_name: item.name,
					content_ids: [item._productId],
					content_type: 'product_group',
					value: item.price,
					currency: 'USD',
				});

			const klaviyoItem = {
				ProductName: item.title,
				ProductID: item._productId,
				URL: `https://dimshome.com/products/${item._slug}`,
				Brand: 'Pasque',
				Price: item.price,
			};

			global._learnq = global._learnq || [];
			global._learnq.push(['track', 'Viewed Product', klaviyoItem]);
			global._learnq.push([
				'trackViewedItem',
				{
					Title: item.title,
					ItemId: item._productId,
					URL: `https://dimshome.com/products/${item._slug}`,
					Metadata: {
						Price: item.price,
					},
				},
			]);

			global.ga &&
				global.ga('ec:addImpression', {
					name: item.title,
					price: item.price,
					category: 'Furniture',
					brand: 'Pasque',
				});

			global.pintrk &&
				global.pintrk('track', 'PageVisit', {
					product_name: item.title,
					product_id: item.id,
					price: item.price,
					currency: 'USD',
				});
		},
		addToCart(item = {}) {
			gtag('event', 'add_to_cart', {items: [item]});

			global.ga && global.ga('ec:addProduct', item);

			global.pintrk &&
				global.pintrk('track', 'AddToCart', {
					product_name: item.name,
					product_id: item.id,
					price: item.price,
					order_quantity: item.quantity,
					currency: 'USD',
				});

			global.fbq &&
				global.fbq('track', 'AddToCart', {
					content_name: item.name,
					content_ids: [item._productId],
					content_type: 'product_group',
					value: item.price,
					currency: 'USD',
				});
		},
		removeFromCart(item = {}) {
			gtag('event', 'remove_from_cart', {items: [item]});

			global.ga && global.ga('ec:removeProduct', item);
		},
		clickCheckout() {
			gtag('event', 'Click Checkout');
			global.fbq && global.fbq('track', 'InitiateCheckout');
		},
		trackFormLead(lead) {
			global.fbq && global.fbq('track', 'Lead');
			global.fbq && global.fbq('track', lead);
		},
	};
};

//
// === Group all script tags here` ===
//

export default ({
	gtmPropertyId,
	googleAnalyticsPropertyId,
	facebookPixelId,
	okendoSubscriberId,
	affirmApiKey,
	klaviyoCompanyId,
	hotJarId,
	shareASaleId,
	heapId,
	pinterestId,
}) => (
	<React.Fragment>
		<Helmet>
			{/* TODO: ADD GTM */}
			{/* GA */}
			{/* <script
				async
				src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsPropertyId}`}
			/> */}
			{/* Facebook */}
			{/* <script>{`
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window,document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '${facebookPixelId}');
			`}</script> */}
			{/* Okendo Review */}

			{/* Klaviyo */}
			<script
				async
				type="text/javascript"
				src={`//static.klaviyo.com/onsite/js/klaviyo.js?company_id=${klaviyoCompanyId}`}
			/>
			{/* Share a Sale */}
		</Helmet>
		{/* TODO: ADD GTM */}
	</React.Fragment>
);
